import PasswordResetRequestForm from '../../modules/signin/PasswordResetRequestForm';

export default PasswordResetRequestForm;
